<template>
  <div>
    <v-sheet class="text-center py-16">
      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
      <p class="mt-4 text-caption" v-html="$t('page.pay.pay-progress-text')"></p>
    </v-sheet>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"

export default {
  created() {},
  mounted() {
    let amount = this.$route.query.amount
    let orderId = this.$route.query.orderId
    let paymentKey = this.$route.query.paymentKey

    this.doPayCompleted({
      orderNo: orderId,
      paymentKey,
      amount: Number(amount),
      isAbroad: true,
    })
      .then((res) => {
        // 결제가 끝났으니 담아 둔 예약 선택을 지운다(토스 성공 화면과 같게)
        try {
          window.localStorage.removeItem("lafia_booking_draft_v2")
        } catch (error) {}
      })
      .catch((e) => {
        const errorMessage = e.response?.data || "Unknown Error"
        console.log(e)
        //alert(this.$t("alert.error_doing_pay_unknown_error"))
        alert(this.$t("alert.error_doing_pay_unknown_error_with_message", { message: errorMessage }))
      })
  },

  methods: {
    ...mapActions(["doPayCompleted"]),
  },
}
</script>
<style></style>
